import allocationTranslations from '~/modules/shipment-allocations/translations';
import detailPricingTranslation from '~/modules/shipment-detail-pricing/translations';
import detailShipmentsTranslation from '~/modules/shipment-detail-shipment/translations';
import fleetTranslations from '~/modules/vehicle/translations';
import { DoEventName } from '../shipment-detail-customer/constants';

const DICTIONARIES = {
  en: {
    activity_log: 'Activity Log',
    actual_overtime_hours: 'Actual Overtime Hours',
    actual_pricing_unit: 'Actual Pricing Unit',
    actual_receiver_name: 'Actual Receiver Name',
    additional_notes: 'Additional Notes',
    address: 'Address',
    allocations: allocationTranslations.en,
    assign: 'Assign',
    assign_do: 'Assign DO',
    assigned: 'Assigned',
    assignment_close: {
      cancel: 'Yes, Cancel',
      not_cancel: 'No, Stay Here',
      title_text_action: 'Cancel {{action}}?',
      content_text_action: 'All changes you made so far will not be saved and you will have to update the current {{action}} again.',
    },
    assignment_errors: {
      replacement_fleet_required: 'Select replacement fleet',
      transporter_price_required: 'Transporter price is required for On-call contract',
    },
    at_destination: 'At Destination',
    at_origin: 'At Origin',
    awb_id: 'AWB ID',
    awb_details: 'AWB Details',
    body_type: 'Body Type',
    cancel_do: 'Cancel DO',
    cancel_reason: 'Cancel Reason',
    cancelled: 'Cancelled',
    capacity: 'Capacity',
    cod_amount: 'COD Amount',
    complete_status: 'Complete Status',
    completed: 'Completed',
    contact: 'Contact',
    contract_code: 'Contract Code',
    contract_period: 'Contract Period',
    contract_type: 'Contract Type',
    convert_routing_to_do: 'Convert Routing To DO',
    create_new_allocation: 'Create New Allocation',
    create_new_do_awb: 'Create New DO & AWB',
    create_new_routing_data: 'Create New Routing Data',
    current_assignment: 'Current Assignment',
    customer: 'Customer',
    customer_did_not_order: 'Customer Did Not Order',
    customer_logs: {
      [DoEventName.DoFleetUpdated]: 'Shipment edited',
      [DoEventName.ShipmentAllocationQueued]: 'Shipment queued',
      [DoEventName.ShipmentAssigned]: 'Shipment assigned',
      [DoEventName.ShipmentCreated]: 'Shipment created',
      [DoEventName.ShipmentEdited]: 'Shipment edited',
      [DoEventName.ShipmentReassigned]: 'Shipment reassigned',
    },
    delivery_date: 'Delivery Date',
    delivery_order: 'Delivery Order',
    destination_action_datetime: 'Destination Action Date Time',
    destination_address: 'Destination Address',
    destination_city: 'Destination City',
    destination_id: 'Destination ID',
    destination_latitude: 'Destination Latitude',
    destination_longitude: 'Destination Longitude',
    destination_name: 'Destination Name',
    destination_notes: 'Destination Notes',
    destination_phone: 'Destination Phone',
    destination_pic_contact: 'Destination PIC contact',
    destination_pic_name: 'Destination PIC Name',
    destination_zipcode: 'Destination Zipcode',
    detail_pricings: detailPricingTranslation.en,
    detail_shipments: detailShipmentsTranslation.en,
    dimension: 'Dimension',
    discount: 'Discount',
    discount_flat_value: 'Discount Flat Value',
    discount_percentage_max_amount: 'Discount Percentage Max Amount',
    discount_percentage_value: 'Discount Percentage Value',
    discount_type: 'Discount Type',
    documents: 'Documents',
    do_conversion_template: 'DO Conversion Template',
    do_details: 'DO Details',
    do_id: 'DO ID',
    do_planned_pricing_unit: 'DO Planned Pricing Unit',
    doNumber_successfully_x: '{{doNumber}} successfully {{x}}',
    download_as_csv: 'Download as CSV',
    download_selected_data: 'Download Selected Data',
    driver_ksuid: 'Driver ID',
    driver_note: 'Driver Note',
    driver_notes: 'Driver Notes',
    dropoff: 'Drop-off',
    drop_order: 'Drop Order',
    duplicate_order: 'Duplicate Order',
    empty_do_template: 'Empty DO Template',
    empty_routing_template: 'Empty Routing Template',
    eta: 'ETA',
    eta_destination: 'ETA Destination',
    etd: 'ETD',
    etd_destination: 'ETD Destination',
    existing_awb_data: 'Existing AWB Data',
    existing_do: 'Existing DO',
    existing_do_allocation: 'Existing DO Allocation',
    existing_routing_data: 'Existing Routing Data',
    external_cancel: 'External Cancel',
    extra_helper_amount: 'Extra Helper Amount',
    extra_helper_price: 'Extra Helper Price',
    failed: 'Failed',
    finish_loading: 'Finish Loading',
    finish_unloading: 'Finish Unloading',
    fleet: fleetTranslations.en,
    fleet_ksuid: 'Fleet ID',
    fleet_license_plate: 'Fleet Plate Number',
    fully_completed: 'Fully Completed',
    incomplete_reason: 'Incomplete Reason',
    incorrect_do_id_uploaded: 'Incorrect DO ID uploaded',
    incomplete_status_reason: 'incomplete status reason',
    initial_fleet: 'Initial Fleet',
    insufficient_fund: 'Insufficient Fund',
    insufficient_time: 'Insufficient Time',
    insurance_load_value: 'Insurance Load Value',
    insurance_price: 'Insurance Price',
    internal_cancel: 'Internal Cancel',
    internal_notes: 'Internal Notes',
    is_cancel: 'Is Cancel',
    item_detail: 'Item Detail',
    items_damaged: 'Items Damaged',
    last_update: 'Last Updated',
    latest_drop_time: 'Latest Drop Time',
    latitude_and_longitude: 'Latitude & Longitude',
    license_plate: 'License Plate',
    loading_date_time: 'Loading Date Time',
    loading_time: 'Loading Time',
    modal_cancel_back_button: 'No, Go Back',
    modal_cancel_confirmation_button: 'Yes, Cancel',
    modal_cancel_content: 'If you cancel, you will have to create a new DO again.',
    modal_cancel_textarea_label: 'Reason for Cancellation',
    modal_cancel_textarea_placeholder: 'Enter the Reason',
    modal_unfulfilled_back_button: 'No, Cancel',
    modal_unfulfilled_content: 'You will have to create a DO again.',
    new_assignment: 'New Assignment',
    note: 'Note',
    on_shipment: 'On Shipment',
    ongoing_to_destination: 'Ongoing To Destination',
    ongoing_to_origin: 'Ongoing To Origin',
    order_reference: 'Order Reference',
    origin_id: 'Origin ID',
    origin_name: 'Origin Name',
    out_of_stock: 'Out Of Stock',
    partially_completed: 'Partially Completed',
    payments: 'Payments',
    pickup_time: 'Pickup time',
    pickup: 'Pickup',
    planned: 'Planned',
    planned_pricing_unit: 'Planned Pricing Unit',
    pod_return_address: 'Pod Return Address',
    pod_return_price: 'Pod Return Price',
    pod_upload: 'POD Upload',
    pod_uploaded: 'Pod Uploaded',
    price_final: 'Price Final',
    price_suggestion: 'Price Suggestion',
    pol_upload: 'POL Upload',
    pol_uploaded: 'POL Uploaded',
    pricing: 'Pricing',
    pricing_scheme: 'Pricing Scheme',
    product_type: 'Product Type',
    project_alias: 'Project Alias',
    project_name: 'Project Name',
    project_ksuid: 'Project ID',
    project_period: 'Project Period',
    project_type: 'Project Type',
    queued: 'Queued',
    reassign: 'Reassign',
    reassign_do: 'Reassign DO',
    reassigned: 'Reassigned',
    reassignment: 'Reassignment',
    replacement_fleet: 'Replacement Fleet',
    request_problem: 'There’s a problem with your request',
    routing_id: 'Routing ID',
    shipment_notes: 'Shipment Notes',
    shipment_status: 'Shipment Status',
    shipment_statuses_map: {
      ASSIGNED: 'Assigned',
      CANCELLED: 'Cancelled',
      COMPLETED: 'Completed',
      ON_SHIPMENT: 'On Shipment',
      PLANNED: 'Planned',
      UNASSIGNED: 'Unassigned',
      UNFULFILLED: 'Unfulfilled',
    },
    shipment: 'Shipment',
    shipments: 'Shipments',
    shipment_date: 'Shipment date',
    shipper_ksuid: 'Shipper ID',
    shipper_name: 'Shipper Name',
    shipper_notes: 'Shipper Notes',
    start_loading: 'Start Loading',
    start_unloading: 'Start Unloading',
    store_closed: 'Store Closed',
    store_not_found: 'Store Not Found',
    supply_type: 'Supply Type',
    task_id: 'Task ID',
    timestamp_status: 'Timestamp Status',
    tour_id: 'Tour ID',
    transporter_driver: 'Transporter Driver',
    transporter_driver_parentheses: 'Transporter (Driver)',
    transporter_fleet_ksuid: 'Transporter Fleet ID',
    transporter_fleet: 'Transporter Fleet',
    transporter_fleet_parentheses: 'Transporter (Fleet)',
    transporter_fleet_name: 'Transporter Fleet Name',
    transporter_price: 'Transporter Price',
    unassigned: 'Unassigned',
    unfulfilled: 'Unfulfilled',
    unfulfill_do: 'Unfulfill DO',
    unloading_time: 'Unloading Time',
    update_existing_do_allocation: 'Update Existing DO / Allocation',
    update_existing_do_data: 'Update Existing DO Data',
    update_existing_routing_data: 'Update Existing Routing Data',
    updated_existing_awb_data: 'Updated Existing AWB Data',
    updated_to: 'Updated To',
    update_shipment_status: 'Update Shipment Status',
    upload_to_update_awb: 'Upload to update AWB',
    upload_to_update_do: 'Upload to update DO',
    vehicle_contract_code: 'Vehicle Contract Code',
    wrong_price: 'Wrong Price',
    wrong_quantity: 'Wrong Quantity',
    wrong_sku: 'Wrong SKU',
  },
};

export default DICTIONARIES;
